var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 256.276V9.103A8.829 8.829 0 0 1 8.828.275h379.586L0 256.276z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 79.724v247.172a8.829 8.829 0 0 1-8.828 8.828H123.586L512 79.724z",
    fill: "#4173CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 84.702V9.103a8.829 8.829 0 0 0-8.828-8.828H383.139L0 251.298v75.598a8.829 8.829 0 0 0 8.828 8.828h120.033L512 84.702z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 53.047V9.103a8.829 8.829 0 0 0-8.828-8.828h-71.718L0 282.953v43.944a8.829 8.829 0 0 0 8.828 8.828h71.718L512 53.047z",
    fill: "#464655"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTz);
export default __webpack_public_path__ + "static/media/tz.17873d2dc8e6b0e57ed37011a501f48a.svg";
export { ForwardRef as ReactComponent };